





import React from 'react';
import { motion } from 'framer-motion';
import { Check, Sparkles } from 'lucide-react';
import { cardThemes as themes } from "../utils/cardThemes";


const ThemeSelector = ({ selectedTheme, onSelectTheme }) => {


  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Title */}
      <div>
        <h4 style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 8 }}>SELECT CARD THEME</h4>
        <p style={{ color: '#6b7280', fontSize: 14 }}>Choose a professional design that matches your brand</p>
      </div>

      {/* Theme List */}
      <div style={{ display: 'flex', gap: 16, overflowX: 'auto', paddingBottom: 8, }}>
        {themes.map((theme, index) => {
          const isSelected = selectedTheme?.id === theme.id;
          return (
            <motion.button
              key={theme.id}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.05 }}
              whileHover={{ y: -6 }}
              onClick={() => onSelectTheme(theme)}
              style={{
                position: 'relative',
                minWidth: 80,
                borderRadius: 16,
                border: isSelected ? '2px solid #6366f1' : '2px solid #e5e7eb',
                background: '#fff',
                padding: 0,
                cursor: 'pointer',
                boxShadow: isSelected
                  ? '0 10px 25px rgba(99,102,241,0.3)'
                  : '0 4px 12px rgba(0,0,0,0.05)',
              }}
            >
              {/* Premium badge */}
              {theme.category === 'premium' && (
                <div style={{ position: 'absolute', top: 8, left: 8, background: 'linear-gradient(to right, #f59e0b, #f97316)', padding: '4px 8px', borderRadius: 999, display: 'flex', alignItems: 'center', gap: 4, color: '#fff', fontSize: 10, fontWeight: 'bold', }}>
                  <Sparkles size={12} />
                  PRO
                </div>
              )}

              {/* Preview */}
              <div style={{ height: 100, padding: 16, background: theme.colors.cardBg, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10, }}>
                <div style={{ width: 48, height: 48, borderRadius: '50%', background: theme.colors.primary, }} />

                <div style={{ width: '100%' }}>
                  <div style={{ height: 8, background: theme.colors.text, opacity: 0.8, borderRadius: 4, marginBottom: 6, }} />
                  <div style={{ height: 8, width: '70%', background: theme.colors.textSecondary, opacity: 0.5, borderRadius: 4, }} />
                </div>

                <div style={{ width: '100%', height: 24, background: theme.colors.buttonBg, borderRadius: theme.styles.buttonRadius, marginTop: 8, }} />
              </div>

              {/* Name */}
              <div style={{ padding: 8, borderTop: '1px solid #e5e7eb', background: '#fff', }}>
                <p style={{ fontSize: 12, fontWeight: '600', textAlign: 'center', margin: 0, }}>{theme.name}</p>
                <p style={{ fontSize: 11, color: '#6b7280', textAlign: 'center', margin: 0, textTransform: 'capitalize', }}>{theme.category}</p>
              </div>

              {/* Selected Icon */}
              {isSelected && (
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  style={{ position: 'absolute', top: 8, right: 8, width: 24, height: 24, borderRadius: '50%', background: '#6366f1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', }}
                >
                  <Check size={16} />
                </motion.div>
              )}
            </motion.button>
          );
        })}
      </div>

      {/* Warning */}
      {!selectedTheme && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          style={{ padding: 12, borderRadius: 12, background: '#fef3c7', border: '1px solid #fde68a', fontSize: 13, color: '#92400e', }}
        >
          ⚠️ Please select a theme to continue
        </motion.div>
      )}
    </div>
  );
};

export default ThemeSelector;
